import { gatewayInstance } from "../axiosInstance";

const BASE_TRANSPORT = "/transportservice";
const FUEL_REQUEST_BASE = `${BASE_TRANSPORT}/fuelrequest`;

const handleApiError = (error, contextMsg = "API Error") => {
    console.error(`[FuelRequest API] ${contextMsg}:`, error?.response?.data || error.message || error);
    throw error;
};

export const addFuelRequestData = async ({ fuelRequestRequest, author }) => {
    try {
        const response = await gatewayInstance.post(FUEL_REQUEST_BASE, {
            fuelRequestRequest,
            author,
        });
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to save Fuel Request");
    }
};

export const getFuelRequestDataById = async (id) => {
    try {
        const response = await gatewayInstance.get(`${FUEL_REQUEST_BASE}/${id}`);
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to fetch Fuel Request");
    }
};

export const searchFuelRequest = async (searchRequest = {}) => {
    try {
        const response = await gatewayInstance.post(`${FUEL_REQUEST_BASE}/search`, searchRequest);
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to search Fuel Requests");
    }
};

export const approveFuelRequestByApprover = async ({
                                                       frqId,
                                                       frqApprovedAmount,
                                                       frqApproverRemarks,
                                                       author,
                                                   }) => {
    try {
        const response = await gatewayInstance.put(`${FUEL_REQUEST_BASE}/approve`, {
            frqId,
            frqApprovedAmount,
            frqApproverRemarks,
            author,
        });
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to approve Fuel Request");
    }
};

export const rejectFuelRequestByApprover = async ({ frqId, frqRejectRemarks, author }) => {
    try {
        const response = await gatewayInstance.put(`${FUEL_REQUEST_BASE}/reject`, {
            frqId,
            frqRejectRemarks,
            author,
        });
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to reject Fuel Request");
    }
};

export const approveFuelRequestByPumper = async ({
                                                     frqId,
                                                     frqTopUpAmount,
                                                     frqPumperRemarks,
                                                     author,
                                                 }) => {
    try {
        const response = await gatewayInstance.put(`${FUEL_REQUEST_BASE}/pumper/approve`, {
            frqId,
            frqTopUpAmount,
            frqPumperRemarks,
            author,
        });
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to approve Fuel Top Up");
    }
};

export const rejectFuelRequestByPumper = async ({ frqId, frqRejectRemarks, author }) => {
    try {
        const response = await gatewayInstance.put(`${FUEL_REQUEST_BASE}/pumper/reject`, {
            frqId,
            frqRejectRemarks,
            author,
        });
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to reject Fuel Top Up");
    }
};

export const getFuelRequestJobOptions = async (searchText) => {
    try {
        const response = await gatewayInstance.get(`${FUEL_REQUEST_BASE}/jobs/search`, {
            params: { searchText }
        });
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to fetch job options");
    }
};